import { AdminApi } from './modules/admin/services/admin-api.service';
import { AmountApi } from './modules/master-data/relations/amount/services/amount-api.service';
import { CountryApi } from './modules/master-data/relations/country/services/country-api.service';
import { CourseApi } from './modules/master-data/relations/course/services/course-api.service';
import { EducationFormApi } from './modules/master-data/relations/education-form/services/education-form-api.service';
import { EducationLocationApi } from './modules/master-data/relations/education-location/services/education-location-api.service';
import { EducationTypeApi } from './modules/master-data/relations/education-type/services/education-type-api.service';
import { HospitalApi } from './modules/master-data/relations/hospital/services/hospital-api.service';
import { InstructorStatusApi } from './modules/master-data/relations/instructor-status/services/instructor-status-api.service';
import { LegislationApi } from './modules/master-data/relations/legislation/services/legislation-api.service';
import { PositionApi } from './modules/master-data/relations/position/services/position-api.service';
import { ReasonForAbsenceApi } from './modules/master-data/relations/reason-for-absence/services/reason-for-absence-api.service';
import { SpecialityApi } from './modules/master-data/relations/speciality/services/speciality-api.service';
import { WorkMonthApi } from './modules/master-data/relations/work-month/services/work-month-api.service';
import { YearlyEventApi } from './modules/master-data/relations/yearly-event/services/yearly-event-api.service';
import { EducationMonthApi } from './modules/monthly-data-entry/relations/education-month/services/education-month-api.service';
import { PersonHasEducationElementApi } from './modules/person/relations/person-has-education-element/services/person-has-education-element-api.service';
import { AbsenceApi } from './modules/person/relations/absence/services/absence-api.service';
import { ContractApi } from './modules/person/relations/contract/services/contract-api.service';
import { EducationApi } from './modules/person/relations/education/services/education-api.service';
import { PersonDetailsApi } from './modules/person/relations/person-details/services/person-details-api.service';
import { PersonHasCourseApi } from './modules/person/relations/person-has-course/services/person-has-course-api.service';
import { PersonHasEducationLocationApi } from './modules/person/relations/person-has-education-location/services/person-has-education-location-api.service';
import { PersonHasPartExamApi } from './modules/person/relations/person-has-part-exam/services/person-has-part-exam-api.service';
import { QualificationApi } from './modules/person/relations/qualification/services/qualification-api.service';
import { TutorReportApi } from './modules/person/relations/tutor-report/services/tutor-report-api.service';
import { PersonApi } from './modules/person/services/person-api.service';
import { PostGraduateEducationElementApi } from './modules/post-graduate-education-template/relations/post-graduate-education-element/services/post-graduate-education-element-api.service';
import { PostGraduateEducationModuleApi } from './modules/post-graduate-education-template/relations/post-graduate-education-module/services/post-graduate-education-module-api.service';
import { PostGraduatePartExamHasElementApi } from './modules/post-graduate-education-template/relations/post-graduate-part-exam-has-element/services/post-graduate-part-exam-has-element-api.service';
import { PostGraduatePartExamTemplateApi } from './modules/post-graduate-education-template/relations/post-graduate-part-exam-template/services/post-graduate-part-exam-template-api.service';
import { PostGraduateEducationTemplateApi } from './modules/post-graduate-education-template/services/post-graduate-education-template-api.service';
import { EducationProgressApi } from './modules/person/relations/education-progress/services/education-progress.service';
import { ExportApi } from './modules/person/services/export-api.service';
import { NewExportApi } from './modules/export/services/export-api.service';
import { PersonHasPaymentApi } from './modules/person/relations/person-has-payment/services/person-has-payment-api.service';
import { TransactionApi } from './modules/transaction-data/services/transaction-data-api.service';
import { LoginTransactionApi } from './modules/login-transaction-data/services/login-transaction-data-api.service';
import { SpecialityHasCourseApi } from './modules/master-data/relations/speciality-has-course/services/speciality-has-course-api.service';
import { ReducedWorkScheduleApi } from './modules/person/relations/reduced-work-schedule/services/absence-api.service';
import { NationalityApi } from './modules/master-data/relations/nationality/services/nationality-api.service';

const modules = {
  admin: new AdminApi(),
  position: new PositionApi(),
  speciality: new SpecialityApi(),
  educationType: new EducationTypeApi(),
  country: new CountryApi(),
  reasonForAbsence: new ReasonForAbsenceApi(),
  amount: new AmountApi(),
  nationality: new NationalityApi(),
  instructorStatus: new InstructorStatusApi(),
  educationForm: new EducationFormApi(),
  course: new CourseApi(),
  hospital: new HospitalApi(),
  educationLocation: new EducationLocationApi(),
  workMonth: new WorkMonthApi(),
  qualification: new QualificationApi(),
  contract: new ContractApi(),
  personDetails: new PersonDetailsApi(),
  absence: new AbsenceApi(),
  person: new PersonApi(),
  transaction: new TransactionApi(),
  loginTransaction: new LoginTransactionApi(),
  export: new ExportApi(),
  newExport: new NewExportApi(),
  personHasEducationLocation: new PersonHasEducationLocationApi(),
  legislation: new LegislationApi(),
  postGraduateEducationTemplate: new PostGraduateEducationTemplateApi(),
  postGraduateEducationModule: new PostGraduateEducationModuleApi(),
  postGraduateEducationElement: new PostGraduateEducationElementApi(),
  education: new EducationApi(),
  educationProgress: new EducationProgressApi(),
  personHasCourse: new PersonHasCourseApi(),
  tutorReport: new TutorReportApi(),
  postGraduatePartExamTemplate: new PostGraduatePartExamTemplateApi(),
  postGraduatePartExamHasElement: new PostGraduatePartExamHasElementApi(),
  yearlyEvent: new YearlyEventApi(),
  educationMonth: new EducationMonthApi(),
  personHasPartExam: new PersonHasPartExamApi(),
  personHasEducationElement: new PersonHasEducationElementApi(),
  personHasPayment: new PersonHasPaymentApi(),
  specialityHasCourse: new SpecialityHasCourseApi(),
  reducedWorkSchedule: new ReducedWorkScheduleApi()
};

export default modules;
